<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/personContractList' }">合同</el-breadcrumb-item>
                <el-breadcrumb-item>合同{{ type == 'update' ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submit('submitForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form :model="formData" :rules="rules" ref="submitForm" label-position="right" class="details_temp2023">
                        <template v-for="(item, index) in colData">
                            <template v-if="formData.hasOwnProperty(item.prop)">
                                <el-form-item
                                    v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'dropdown'"
                                    v-show="
                                        fieldTypeMap[item.prop]['show_flag']
                                            ? fieldTypeMap[item.prop]['show_flag'] == show_flag
                                                ? 1
                                                : 0
                                            : 1
                                    "
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || []"
                                    :prop="item['prop']"
                                >
                                    <vDropdown
                                        :model_key="item['prop']"
                                        :model_name="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :model_value_default="data[item['prop']]"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        :request_params="fieldTypeMap[item.prop]['request_params']"
                                        @onDropChange="onDropChange"
                                        :display_name="fieldTypeMap[item.prop]['display_name']"
                                        :select_value="fieldTypeMap[item.prop]['select_value']"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                        :is_disable="type == 'update' && item['prop'] == 'person_rid'"
                                        :is_init="item['prop'] == 'employment_form' ? false : true"
                                    ></vDropdown>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>

                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'date'"
                                    v-show="
                                        fieldTypeMap[item.prop]['show_flag']
                                            ? fieldTypeMap[item.prop]['show_flag'] == show_flag
                                                ? 1
                                                : 0
                                            : 1
                                    "
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-date-picker
                                        v-model="formData[item['prop']]"
                                        :type="fieldTypeMap[item.prop]['date_type']"
                                        :placeholder="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :format="fieldTypeMap[item.prop]['format']"
                                        :value-format="fieldTypeMap[item.prop]['value_format']"
                                        size="mini"
                                        clearable
                                    >
                                    </el-date-picker>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>
                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'file'"
                                    v-show="
                                        fieldTypeMap[item.prop]['show_flag']
                                            ? fieldTypeMap[item.prop]['show_flag'] == show_flag
                                                ? 1
                                                : 0
                                            : 1
                                    "
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :prop="item['prop']"
                                >
                                    <div>
                                        <el-link type="primary" @click="toDetail(formData[item['prop']])" style="font-size: 11px"
                                            >{{ formData[item['prop']] ? '预览' : '' }}
                                        </el-link>

                                        <el-progress
                                            v-show="contract_pdf_percent"
                                            :percentage="contract_pdf_percent"
                                            color="#67c23a"
                                        ></el-progress>
                                        <input type="file" accept=".pdf" data-num="1" @change="checkFile" style="margin-left: 5px" />
                                    </div>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>

                                <el-form-item
                                    v-else
                                    v-show="
                                        fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['show_flag']
                                            ? fieldTypeMap[item.prop]['show_flag'] == show_flag
                                                ? 1
                                                : 0
                                            : 1
                                    "
                                    :key="index"
                                    :label="item['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-input
                                        v-model="formData[item['prop']]"
                                        size="mini"
                                        :placeholder="'请输入' + item.title"
                                        :disabled="type == 'update' && item['prop'] == 'code'"
                                        clearable
                                    ></el-input>
                                </el-form-item>
                            </template>

                            <template v-else>
                                <el-form-item v-if="type == 'update'" :key="index" :label="item['title'] + '：'">
                                    <div class="read_only">
                                        {{ data[item['prop']] }}
                                    </div>
                                </el-form-item>
                            </template>
                        </template>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { in_array, qiniuPrivateShow, processColDataToEdit } from '@/js/common.js';
import * as qiniu from 'qiniu-js';

export default {
    name: 'personContractEdit',
    data() {
        return {
            type: '', // insert or update or copy
            activeNames: ['1'],
            btnLoading: false,
            provinceCities: [], // 省份城市级联下拉
            contract_pdf_percent: 0,
            show_flag: 0,
            colData: [], // 字段信息
            formData: {}, // 表单信息
            data: {}, // 详情数据
            fieldTypeMap: {},
            queryParams: {}, // 搜索参数（详情）
            rules: {} // 表单验证信息
        };
    },
    created() {
        this.type = this.$route.query.type;
        this.getProvinceCities();
        this.initQueryParams();
        this.selectedColData(); //筛选列

        this.initFormRule();
        this.initFieldTypeMap();
        if (in_array(this.type, ['update', 'copy'])) {
            this.getData();
        } else {
            this.data.person_rid = this.$route.query.person_rid || '';
            this.initFormData();
        }
    },
    methods: {
        // 选择文件上传
        checkFile(e) {
            let files = e.target.files[0];
            const isLt5M = files.size / 1024 / 1024 < 5;
            if (!files.type.match('.pdf')) {
                this.$message.error('请选择PDF格式的文件上传');
                return;
            }
            if (!isLt5M) {
                this.$message.error('上传PDF大小不能超过 5M!');
                return;
            }
            this.fileNumber = e.target.dataset.num;
            this.getToken(files);
        },
        // 获取上去七牛云的doman和token
        getToken(file) {
            let params = {
                type: 1
            };
            this.$api
                .getQiNiuToken(params)
                .then((res) => {
                    if (res.code === 0) {
                        let domain = res.data.domain;
                        let token = res.data.token;
                        this.uploadToQiniuyun(file, token, domain);
                    }
                })
                .catch((err) => {});
        },
        // 上传文件到七牛云
        uploadToQiniuyun(file, token, domain) {
            let name = String(parseInt(Math.random() * 100000)) + '_' + file.name;
            let _this = this;
            const config = {
                useCdnDomain: true,
                region: qiniu.region.z0
            };
            let api = `http://${domain}/`;
            let fileName = `contract_${name}`;
            let putExtra = {
                mimeType: null
            };
            const observable = qiniu.upload(file, fileName, token, putExtra, config);
            observable.subscribe({
                next(res) {
                    _this.contract_pdf_percent = Math.floor(res.total.percent);
                },
                error(err) {
                    switch (err.code) {
                        case 401:
                            _this.$message.error('上传失败，请检查是否登录再重试');
                            break;
                        default:
                            _this.$message.error(err.message);
                            break;
                    }
                },
                complete(res) {
                    let src = `${api}${res.key}`;
                    _this.formData['competition_agreement'] = src;
                }
            });
        },
        onDropChange(key, value) {
            if (key == 'is_competition_agreement') {
                this.show_flag = value;
            } else if (key == 'type') {
                this.$refs.employment_form_ref[0].request_params.type = value;
                this.$refs.employment_form_ref[0].initData();
            }

            this.formData[key] = value;
        },
        getProvinceCities() {
            this.$api
                .provinceCities({})
                .then((res) => {
                    if (res.code == 0) {
                        this.provinceCities = res.data;
                    }
                })
                .catch((error) => {});
        },
        initFieldTypeMap() {
            this.fieldTypeMap = {
                person_rid: {
                    request_uri: 'dropdownPerson',
                    title: '人员',
                    ref: 'person_rid_ref',
                    display_name: 'name',
                    type: 'dropdown'
                },
                labour_contract_entity_rid: {
                    request_uri: 'dropdownAccountByParams',
                    request_params: { type: 10 },
                    title: '主体',
                    ref: 'labour_contract_entity_rid_ref',
                    display_name: 'name',
                    type: 'dropdown'
                },
                type: {
                    request_uri: 'dropdownPersonContractType',
                    title: '类型',
                    ref: 'type_ref',
                    display_name: 'name',
                    select_value: 'value',
                    type: 'dropdown'
                },
                employment_form: {
                    request_uri: 'dropdownEmploymentForm',
                    request_params: { type: 0 },
                    title: '用工形式',
                    ref: 'employment_form_ref',
                    display_name: 'name',
                    select_value: 'value',
                    type: 'dropdown'
                },
                start_date: {
                    title: '开始日期',
                    format: 'yyyy-MM-dd',
                    value_format: 'yyyy-MM-dd',
                    ref: 'start_date_ref',
                    type: 'date'
                },
                end_date: {
                    title: '结束日期',
                    format: 'yyyy-MM-dd',
                    value_format: 'yyyy-MM-dd',
                    ref: 'end_date_ref',
                    type: 'date',
                    tips: '长期请填：2999-12-31'
                },
                is_competition_agreement: {
                    request_uri: 'yesOrNo',
                    title: '是否履行竞业协议',
                    ref: 'is_competition_agreement_ref',
                    display_name: 'name',
                    select_value: 'value',
                    type: 'dropdown'
                },
                competition_agreement_start_date: {
                    title: '协议开始日期',
                    format: 'yyyy-MM-dd',
                    value_format: 'yyyy-MM-dd',
                    ref: 'competition_agreement_start_date_ref',
                    type: 'date',
                    tips: '如果履行竞业协议，日期必填',
                    show_flag: 1
                },
                competition_agreement_end_date: {
                    title: '协议结束日期',
                    format: 'yyyy-MM-dd',
                    value_format: 'yyyy-MM-dd',
                    ref: 'competition_agreement_end_date_ref',
                    type: 'date',
                    tips: '如果履行竞业协议，日期必填',
                    show_flag: 1
                },
                competition_agreement: {
                    title: '协议说明',
                    ref: 'competition_agreement_ref',
                    type: 'file',
                    tips: '只能上传pdf文件，最大5M',
                    show_flag: 1
                }
            };
        },
        initFormRule() {
            this.rules = {
                code: [{ required: true, message: '请输入代码', trigger: 'blur' }],
                person_rid: [{ required: true, message: '请选择人员', trigger: 'blur' }],
                labour_contract_entity_rid: [{ required: true, message: '请选择主体', trigger: 'blur' }],
                start_date: [{ required: true, message: '请输入开始日期', trigger: 'blur' }],
                end_date: [{ required: true, message: '请输入结束日期', trigger: 'blur' }],
                type: [{ required: true, message: '请选择类型', trigger: 'blur' }],
                employment_form: [{ required: true, message: '请选择用工形式', trigger: 'blur' }],
                is_competition_agreement: [{ required: true, message: '是否履行竞业协议', trigger: 'blur' }]
            };
        },
        initQueryParams() {
            this.queryParams.rid = this.$route.query.id;
        },
        initFormData() {
            this.formData = {
                rid: this.data.rid || '',
                code: this.data.code || '',
                person_rid: this.data.person_rid || '',
                labour_contract_entity_rid: this.data.labour_contract_entity_rid || '',
                start_date: this.data.start_date || '',
                end_date: this.data.end_date || '',
                type: this.data.type || '',
                employment_form: this.data.employment_form || '',
                remark: this.data.remark || '',
                is_competition_agreement: this.data.is_competition_agreement || '',
                competition_agreement_start_date: this.data.competition_agreement_start_date || '',
                competition_agreement_end_date: this.data.competition_agreement_end_date || '',
                competition_agreement: this.data.competition_agreement || ''
            };
            this.show_flag = this.data.is_competition_agreement;
        },
        //筛选列
        selectedColData() {
            let temp = JSON.parse(localStorage.getItem('detailList')).person_contract;

            processColDataToEdit(
                temp,
                this,
                {
                    white: [
                        'code',
                        'start_date',
                        'end_date',
                        'remark',
                        'competition_agreement',
                        'competition_agreement_start_date',
                        'competition_agreement_end_date'
                    ]
                },
                {
                    type_label: 'type',
                    employment_form_label: 'employment_form',
                    is_competition_agreement_label: 'is_competition_agreement',
                    person: 'person_rid',
                    entity: 'labour_contract_entity_rid'
                }
            );
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/personContractList' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getData() {
            this.$api
                .personContractDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    this.initFormData();
                    window.setTimeout(() => {
                        this.onDropChange('type', res.data.type);
                    }, 500);
                })
                .catch((error) => {});
        },
        //提交新增/编辑修改
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.doSubmit();
                    return true;
                } else {
                    return false;
                }
            });
        },
        doSubmit() {
            this.btnLoading = true;
            let uri = '';
            if (this.type == 'update') {
                uri = 'personContractUpdate';
            } else {
                uri = 'personContractInsert';
            }
            this.$api[uri](this.formData)
                .then((res) => {
                    this.btnLoading = false;
                    this.$message({
                        message: '保存成功！',
                        type: 'success'
                    });
                    this.cancel();
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        },
        toDetail(url) {
            qiniuPrivateShow(url, this);
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>